var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "finance-todo-list" },
    [
      _c("aside", { staticClass: "category-panel" }, [
        _c(
          "button",
          {
            staticClass: "category-card",
            class: { active: _vm.activeCategory === "negativeProfitOrder" },
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.switchCategory("negativeProfitOrder")
              }
            }
          },
          [
            _c("div", { staticClass: "category-name" }, [
              _c("span", { staticClass: "name-text" }, [_vm._v("负毛利订单")]),
              _c("span", { staticClass: "count-badge" }, [
                _vm._v(_vm._s(_vm.pendingCount))
              ])
            ])
          ]
        ),
        _c(
          "button",
          {
            staticClass: "category-card",
            class: { active: _vm.activeCategory === "payableUnverifiedOrder" },
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.switchCategory("payableUnverifiedOrder")
              }
            }
          },
          [_vm._m(0)]
        )
      ]),
      _c(
        "section",
        { staticClass: "todo-content" },
        [
          _vm.activeCategory === "negativeProfitOrder"
            ? [
                _c(
                  "div",
                  { staticClass: "filter-bar" },
                  [
                    _c("el-input", {
                      staticClass: "filter-item",
                      attrs: { placeholder: "批次号", clearable: "" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.search($event)
                        }
                      },
                      model: {
                        value: _vm.negativeFilter.batchNo,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.negativeFilter,
                            "batchNo",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "negativeFilter.batchNo"
                      }
                    }),
                    _c("el-input", {
                      staticClass: "filter-item",
                      attrs: { placeholder: "订单号", clearable: "" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.search($event)
                        }
                      },
                      model: {
                        value: _vm.negativeFilter.jobNo,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.negativeFilter,
                            "jobNo",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "negativeFilter.jobNo"
                      }
                    }),
                    _c("el-input", {
                      staticClass: "filter-item",
                      attrs: { placeholder: "客户", clearable: "" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.search($event)
                        }
                      },
                      model: {
                        value: _vm.negativeFilter.customerName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.negativeFilter,
                            "customerName",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "negativeFilter.customerName"
                      }
                    }),
                    _c(
                      "el-radio-group",
                      {
                        staticClass: "status-group",
                        on: { change: _vm.search },
                        model: {
                          value: _vm.negativeFilter.handleStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.negativeFilter, "handleStatus", $$v)
                          },
                          expression: "negativeFilter.handleStatus"
                        }
                      },
                      [
                        _c("el-radio-button", { attrs: { label: "" } }, [
                          _vm._v("全部")
                        ]),
                        _c("el-radio-button", { attrs: { label: 0 } }, [
                          _vm._v("未处理")
                        ]),
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v("已处理")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", icon: "el-icon-search" },
                        on: { click: _vm.search }
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-refresh-left" },
                        on: { click: _vm.reset }
                      },
                      [_vm._v("重置")]
                    ),
                    _vm.$store.getters.isAdmin
                      ? _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-refresh" },
                            on: { click: _vm.manualGenerate }
                          },
                          [_vm._v("手动补跑")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { ref: "tableWrapper", staticClass: "table-wrapper" },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        ref: "orderTable",
                        staticClass: "order-table",
                        attrs: {
                          data: _vm.negativeList,
                          "row-key": "uuid",
                          "max-height": _vm.tableMaxHeight,
                          "highlight-current-row": "",
                          "header-cell-style": {
                            background: "#f5f7fa",
                            color: "#303133"
                          }
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "订单号", "min-width": "210" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "job-cell" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "job-no",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.openOrder(row)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(row.jobNo))]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "复制订单号",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c("el-button", {
                                              staticClass: "copy-job-no",
                                              attrs: {
                                                type: "text",
                                                icon: "el-icon-document-copy"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.copyJobNo(
                                                    row.jobNo,
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4289703314
                          )
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "batchNo",
                            label: "批次号",
                            "min-width": "130",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "customerName",
                            label: "客户",
                            "min-width": "190",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _vm._v(_vm._s(row.customerName || "-"))
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1991890673
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { label: "ETD", width: "105" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _vm._v(_vm._s(_vm.formatDate(row.etd)))
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            315216444
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { label: "业务类型", width: "95" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatBusinessType(row.businessType)
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2802934813
                          )
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "毛利（本位币）",
                            "min-width": "145",
                            align: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c("span", { staticClass: "profit" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatAmount(row.grossProfit)
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1194603126
                          )
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "销售",
                            width: "110",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [_vm._v(_vm._s(row.salesName || "-"))]
                                }
                              }
                            ],
                            null,
                            false,
                            2820527645
                          )
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "客服",
                            width: "110",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [_vm._v(_vm._s(row.csrName || "-"))]
                                }
                              }
                            ],
                            null,
                            false,
                            2328338423
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { label: "处理人", width: "150" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    row.handleHistories &&
                                    row.handleHistories.length
                                      ? _c(
                                          "div",
                                          { staticClass: "handler-history" },
                                          _vm._l(row.handleHistories, function(
                                            history
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: history.uuid,
                                                staticClass: "handler-item"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "handler-name"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        history.operatorName ||
                                                          "-"
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "handler-time"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatDateTime(
                                                          history.operateTime
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      : row.handleStatus === 1
                                      ? _c("div", { staticClass: "handler" }, [
                                          _c(
                                            "div",
                                            { staticClass: "handler-name" },
                                            [
                                              _vm._v(
                                                _vm._s(row.handlerName || "-")
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "handler-time" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDateTime(
                                                    row.handleTime
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      : _c("span", { staticClass: "pending" }, [
                                          _vm._v("待处理")
                                        ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3951588730
                          )
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reason",
                            label: "原因说明",
                            "min-width": "200",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    row.reason
                                      ? _c("span", [_vm._v(_vm._s(row.reason))])
                                      : _c(
                                          "span",
                                          { staticClass: "reason-empty" },
                                          [_vm._v("未处理")]
                                        )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2562688517
                          )
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            width: "100",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.openReasonDialog(row)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            row.handleStatus === 1
                                              ? "修改备注"
                                              : "备注"
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2064071074
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "div",
                  { staticClass: "filter-bar" },
                  [
                    _c("el-input", {
                      staticClass: "filter-item",
                      attrs: { placeholder: "批次号", clearable: "" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.search($event)
                        }
                      },
                      model: {
                        value: _vm.payableFilter.batchNo,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.payableFilter,
                            "batchNo",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "payableFilter.batchNo"
                      }
                    }),
                    _c("el-input", {
                      staticClass: "filter-item",
                      attrs: { placeholder: "订单号", clearable: "" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.search($event)
                        }
                      },
                      model: {
                        value: _vm.payableFilter.jobNo,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.payableFilter,
                            "jobNo",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "payableFilter.jobNo"
                      }
                    }),
                    _c("el-input", {
                      staticClass: "filter-item",
                      attrs: { placeholder: "客户", clearable: "" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.search($event)
                        }
                      },
                      model: {
                        value: _vm.payableFilter.customerName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.payableFilter,
                            "customerName",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "payableFilter.customerName"
                      }
                    }),
                    _c(
                      "el-radio-group",
                      {
                        staticClass: "status-group",
                        on: { change: _vm.search },
                        model: {
                          value: _vm.payableFilter.chargeNature,
                          callback: function($$v) {
                            _vm.$set(_vm.payableFilter, "chargeNature", $$v)
                          },
                          expression: "payableFilter.chargeNature"
                        }
                      },
                      [
                        _c("el-radio-button", { attrs: { label: "" } }, [
                          _vm._v("全部")
                        ]),
                        _c(
                          "el-radio-button",
                          { attrs: { label: "SPECIAL_PAYABLE" } },
                          [_vm._v("专项应付")]
                        ),
                        _c(
                          "el-radio-button",
                          { attrs: { label: "OTHER_PAYABLE" } },
                          [_vm._v("其他应付")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-radio-group",
                      {
                        staticClass: "status-group",
                        on: { change: _vm.search },
                        model: {
                          value: _vm.payableFilter.handleStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.payableFilter, "handleStatus", $$v)
                          },
                          expression: "payableFilter.handleStatus"
                        }
                      },
                      [
                        _c("el-radio-button", { attrs: { label: "" } }, [
                          _vm._v("全部")
                        ]),
                        _c("el-radio-button", { attrs: { label: 0 } }, [
                          _vm._v("未处理")
                        ]),
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v("已处理")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", icon: "el-icon-search" },
                        on: { click: _vm.search }
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-refresh-left" },
                        on: { click: _vm.reset }
                      },
                      [_vm._v("重置")]
                    ),
                    _vm.$store.getters.isAdmin
                      ? _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-refresh" },
                            on: { click: _vm.manualGenerate }
                          },
                          [_vm._v("手动补跑")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { ref: "tableWrapper", staticClass: "table-wrapper" },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        ref: "orderTable",
                        staticClass: "order-table",
                        attrs: {
                          data: _vm.payableList,
                          "row-key": "uuid",
                          "max-height": _vm.tableMaxHeight,
                          "highlight-current-row": "",
                          "header-cell-style": {
                            background: "#f5f7fa",
                            color: "#303133"
                          }
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "订单号", "min-width": "195" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "job-cell" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "job-no",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function($event) {
                                              return _vm.openOrder(row)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(row.jobNo))]
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: "复制订单号",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c("el-button", {
                                            staticClass: "copy-job-no",
                                            attrs: {
                                              type: "text",
                                              icon: "el-icon-document-copy"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.copyJobNo(
                                                  row.jobNo,
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "batchNo",
                            label: "批次号",
                            "min-width": "120",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "customerName",
                            label: "客户",
                            "min-width": "170",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [_vm._v(_vm._s(row.customerName || "-"))]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: { label: "ETD", width: "100" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [_vm._v(_vm._s(_vm.formatDate(row.etd)))]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: { label: "业务类型", width: "90" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatBusinessType(row.businessType)
                                    )
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: { label: "费用性质", width: "105" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        size: "small",
                                        type:
                                          row.chargeNature === "SPECIAL_PAYABLE"
                                            ? "warning"
                                            : ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatChargeNature(
                                              row.chargeNature
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "应付合计",
                            "min-width": "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    _vm._s(_vm.formatAmount(row.payableAmount))
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "未核销余额",
                            "min-width": "125",
                            align: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("span", { staticClass: "profit" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatUnverifiedAmount(
                                          row.unverifiedAmount
                                        )
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "推送对象",
                            "min-width": "145",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _vm._v(_vm._s(_vm.formatPushUsers(row)))
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: { label: "处理人", width: "145" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  row.handleHistories &&
                                  row.handleHistories.length
                                    ? _c(
                                        "div",
                                        { staticClass: "handler-history" },
                                        _vm._l(row.handleHistories, function(
                                          history
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: history.uuid,
                                              staticClass: "handler-item"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "handler-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      history.operatorName ||
                                                        "-"
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "handler-time" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatDateTime(
                                                        history.operateTime
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : row.handleStatus === 1
                                    ? _c("div", { staticClass: "handler" }, [
                                        _c(
                                          "div",
                                          { staticClass: "handler-name" },
                                          [
                                            _vm._v(
                                              _vm._s(row.handlerName || "-")
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "handler-time" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatDateTime(
                                                  row.handleTime
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    : _c("span", { staticClass: "pending" }, [
                                        _vm._v("待处理")
                                      ])
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reason",
                            label: "原因说明",
                            "min-width": "185",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  row.reason
                                    ? _c("span", [_vm._v(_vm._s(row.reason))])
                                    : _c(
                                        "span",
                                        { staticClass: "reason-empty" },
                                        [_vm._v("未处理")]
                                      )
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "95", fixed: "right" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.openReasonDialog(row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.handleStatus === 1
                                            ? "修改备注"
                                            : "备注"
                                        )
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
          _c(
            "div",
            { ref: "paginationWrapper", staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  total: _vm.currentFilter.total,
                  page: _vm.currentFilter.pageNum,
                  limit: _vm.currentFilter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.currentFilter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.currentFilter, "pageSize", $event)
                  },
                  pagination: _vm.query
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.reasonDialog.visible,
            title: _vm.reasonDialog.title,
            width: "700px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.reasonDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "dialog-summary" }, [
            _c("div", { staticClass: "summary-row" }, [
              _c("span", [
                _vm._v("批次号："),
                _c("b", [_vm._v(_vm._s(_vm.reasonDialog.batchNo))])
              ]),
              _c("span", [
                _vm._v("订单号："),
                _c("b", { staticClass: "job-no" }, [
                  _vm._v(_vm._s(_vm.reasonDialog.jobNo))
                ])
              ]),
              _c("span", [
                _vm._v("客户：" + _vm._s(_vm.reasonDialog.customerName || "-"))
              ])
            ]),
            _vm.reasonDialog.category === "negativeProfitOrder"
              ? _c("div", { staticClass: "summary-row" }, [
                  _c("span", [
                    _vm._v(
                      "ETD：" + _vm._s(_vm.formatDate(_vm.reasonDialog.etd))
                    )
                  ]),
                  _c("span", [
                    _vm._v(
                      "业务类型：" +
                        _vm._s(
                          _vm.formatBusinessType(_vm.reasonDialog.businessType)
                        )
                    )
                  ]),
                  _c("span", [
                    _vm._v("销售：" + _vm._s(_vm.reasonDialog.salesName || "-"))
                  ]),
                  _c("span", [
                    _vm._v("客服：" + _vm._s(_vm.reasonDialog.csrName || "-"))
                  ]),
                  _c("span", [
                    _vm._v("毛利："),
                    _c("b", { staticClass: "profit" }, [
                      _vm._v(
                        _vm._s(_vm.formatAmount(_vm.reasonDialog.grossProfit))
                      )
                    ])
                  ])
                ])
              : _c("div", { staticClass: "summary-row" }, [
                  _c("span", [
                    _vm._v(
                      "ETD：" + _vm._s(_vm.formatDate(_vm.reasonDialog.etd))
                    )
                  ]),
                  _c("span", [
                    _vm._v(
                      "业务类型：" +
                        _vm._s(
                          _vm.formatBusinessType(_vm.reasonDialog.businessType)
                        )
                    )
                  ]),
                  _c("span", [
                    _vm._v(
                      "费用性质：" +
                        _vm._s(
                          _vm.formatChargeNature(_vm.reasonDialog.chargeNature)
                        )
                    )
                  ]),
                  _c("span", [
                    _vm._v(
                      "应付合计：" +
                        _vm._s(_vm.formatAmount(_vm.reasonDialog.payableAmount))
                    )
                  ]),
                  _c("span", [
                    _vm._v("未核销余额："),
                    _c("b", { staticClass: "profit" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatUnverifiedAmount(
                            _vm.reasonDialog.unverifiedAmount
                          )
                        )
                      )
                    ])
                  ])
                ])
          ]),
          _c(
            "el-form",
            {
              ref: "reasonForm",
              attrs: {
                model: _vm.reasonDialog,
                rules: _vm.reasonRules,
                "label-position": "top"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "原因说明", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      maxlength: "1000",
                      "show-word-limit": "",
                      placeholder:
                        "请输入原因说明，如：供应商账期未到 / 费用争议待审 / 付款申请在途..."
                    },
                    model: {
                      value: _vm.reasonDialog.reason,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.reasonDialog,
                          "reason",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "reasonDialog.reason"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "dialog-hint" }, [
            _vm._v(
              "提交后该对象待办自动完成（所有接收人名下同时消失）；已处理对象可修改，记录最新操作人。"
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.reasonDialog.visible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.reasonDialog.submitting
                  },
                  on: { click: _vm.submitReason }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "category-name" }, [
      _c("span", { staticClass: "name-text" }, [_vm._v("应付费用未核销")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }